import { DirectoryPage } from 'components/Directory/DirectoryPage'
import { QVMDirectoryHeader } from 'components/Directory/QVM/QVMDirectoryHeader'
import QVMLogo from 'components/Icons/QVMLogo'
import { NextPage } from 'next'
import React from 'react'

const QVDirectory: NextPage = () => {
  return (
    <DirectoryPage
      vcPrefix="qvm"
      title="QV Melbourne - me&u"
      logo={<QVMLogo height={44} />}
      headerImageUrl="/static/qvm/header.jpg"
      selectPlaceholder="Select your dining area"
      allCollectionsLabel="All dining areas"
    >
      <QVMDirectoryHeader />
    </DirectoryPage>
  )
}

export default QVDirectory
